import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Avatar from '@eversports/klimt-primitives/legacy/Avatar'

interface Props {
  imgSrc?: string
  name: string | null
}

const TeacherAvatar = ({ imgSrc, name }: Props) => (
  <Avatar
    src={imgSrc}
    alt={name || undefined}
    imgProps={{
      loading: 'lazy',
    }}
    sx={{
      height: '80px',
      width: '80px',
      border: '1px solid white',
      filter: `drop-shadow(${boxShadows.default})`,
      borderRadius: 10,
    }}
  />
)

export default TeacherAvatar
